export default __webpack_public_path__ + "static/franchise-presentation-c0c341317236309d1d4afbd08701edcd.png";